import { useUserSettings } from 'src/Hooks'
import { useUserRoles } from 'src/Hooks/user'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { isFlowTheme } from 'src/Libs/utils'
import { useInstallationAccessType } from 'src/Libs/installations/hooks/use-installation-access-type'
import { useActiveInstallationContext } from 'src/Libs/installations'
/**
 * Determines whether the guided dashboard tour should be available to the current user.
 *
 * The tour is available when all of the following conditions are met:
 * - User settings and feature flags have finished loading
 * - The guided tour feature flag is enabled
 * - The user has either 'user' or 'installer' role
 * - The user hasn't disabled guided tours in their settings (defaults to enabled)
 * - The current theme is the Flow theme
 */
export const useDashboardTourAvailability = (): boolean => {
  const {
    isFeatureFlagsLoading,
    featureFlags: { showGuidedTour },
  } = useFeatureFlagsContext()

  const { installation } = useActiveInstallationContext()
  const isFullAccessInstallations = useInstallationAccessType(installation) === 'full-access'

  const { isUser, isInstaller } = useUserRoles()
  const { userSettings, isUserSettingsLoading } = useUserSettings()

  const isLoading = isUserSettingsLoading || isFeatureFlagsLoading
  const isUserInitialGuideSettingEnabled = userSettings.showGuidedTour ?? true
  const shouldShowUserTour = (isUser || isInstaller) && isUserInitialGuideSettingEnabled
  return !isLoading && showGuidedTour && shouldShowUserTour && isFlowTheme && isFullAccessInstallations
}
